<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/19-FCP-reflect-on-your-on-campus-work-experience.svg"
                class="img-fluid"
                alt="Assess your employability skills"
                srcset=""
              >
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- ACCORDION -->
    <!-- <content-block class="p-4">
      <h2 class="content-block__header">Accordion</h2>
      <div class="accordion">
        <accordion
          headerText="Change mindsets"
          accordionID="collapse01"
        >
          <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
        </accordion>
        <accordion
          headerText="Increase social belonging"
          accordionID="collapse02"
        >
          Helping students change their mindset about the malleability of intelligence can change the way they react to setbacks and deal with challenges in the classroom.
        </accordion>
        <accordion
          headerText="Change mindsets"
          accordionID="collapse03"
        >
          <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
        </accordion>
        <accordion
          headerText="Change mindsets"
          accordionID="collapse04"
        >
          <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
        </accordion>
      </div>
    </content-block> -->

    <!-- TEXT CONTENT -->
    <content-block>
      <div class="row">
        <div class="col-md-8 p-4">
          <!-- <h2 class="content-block__header">What do I have to offer?</h2> -->
          <p>It’s a good idea to reflect on how your on-campus work experience has influenced your career goals.</p>
          <p>Remember that it’s up to you to make the case to potential employers that there’s a link between your on-campus work experience and the specific skills valued by the organization you want to work for.</p>
        </div>
        <div class="col-md bg-img bg-img--future-career-19">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
      </div>
    </content-block>
    <content-block class="p-4 bg-light-grey">
        <h2 class="content-block__header">If you completed the employability worksheet from the on-the-job success section of the toolkit…</h2>
        <p>Now that you’ve completed your on-campus work experience, it’s time to reassess your employability skills and see how you’ve developed. Go back to your <a
            :href="`${publicPath}docs/Worksheets/2-Employability skills - worksheet 2.pdf`"
            target="_blank"
          >worksheet</a> and rate your level of competence for each skill again.</p>
        <p>Take a couple of minutes to reflect on your results:</p>
        <div class="carousel carousel--orange">
          <hooper
            ref="carousel_01"
            class="mb-4"
          >
            <slide>
              <div class="slide">
                <p>Is your assessment different from the first time you completed this exercise? Where did you notice improvements?</p>
              </div>
            </slide>

            <slide>
              <div class="slide">
                <p>What do you consider your areas of strength? How did your on-campus experience help strengthen those areas?</p>
              </div>
            </slide>

            <slide>
              <div class="slide">
                <p>What skills do you still need to work on, and how can you go about working on them?</p>
              </div>
            </slide>

            <slide>
              <div class="slide">
                <p>What other jobs, volunteer opportunities or campus experiences will help you further develop your skills?</p>
              </div>
            </slide>

            <hooper-navigation slot="hooper-addons">
              <img
                slot="hooper-prev"
                src="@/assets/img/_ui/svg/carousel-back--orange.svg"
                alt="previous"
                srcset=""
              >
              <img
                slot="hooper-next"
                src="@/assets/img/_ui/svg/carousel-next--orange.svg"
                alt="next"
                srcset=""
              >
            </hooper-navigation>

            <hooper-pagination slot="hooper-addons"></hooper-pagination>
          </hooper>
        </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    // Accordion,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
